import React from "react";
import OrdersGridItem from "./Tab_Orders_Grid_Item";

export default function OrdersGrid(props) {
    const eventTotals = props.selectedEventDetails.eventTotals;
    const hostRewardsSummaries = props.selectedEventDetails.hostRewardsSummaries;
    const custSharedEventOrders = props.selectedEventDetails.custSharedEventOrders;
    const resources = window.jenkon.resources;

    const renderOrdersTable = () => {
        return (
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">{resources["PWS.MyAccount.OrdersTabTableColumnGuest"]}</th>
                        <th scope="col" className="text-right">
                            {resources["PWS.MyAccount.OrdersTabTableColumnOrderTotal"]}
                        </th>
                        <th scope="col" className="text-center">
                            {resources["PWS.MyAccount.OrdersTabTableColumnBookings"]}
                        </th>
                        <th scope="col" className="text-right">
                            {resources["PWS.MyAccount.OrdersTabTableColumnBalance"]}
                        </th>
                        <th scope="col">{resources["PWS.MyAccount.OrdersTabTableColumnActions"]}</th>
                    </tr>
                </thead>
                <tbody>
                    {custSharedEventOrders.map((order, key) => {
                        return <OrdersGridItem key={key} order={order} />;
                    })}
                </tbody>
                <tfoot>
                    <tr>
                        <td scope="col" colSpan={2} className="text-right">
                            <strong>{eventTotals.net.displayValue}</strong>
                        </td>
                        <td scope="col" colSpan={2} className="text-right">
                            <strong>{eventTotals.ordersBalance.displayValue}</strong>
                        </td>
                    </tr>
                </tfoot>
            </table>
        );
    };

    const renderEventTotals = () => {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h5>
                            <strong>{resources["PWS.MyAccount.OrdersTabPartyTotals"]}</strong>
                        </h5>
                    </div>
                </div>

                <div className="row">
                    <span className="col-md-6">{resources["PWS.MyAccount.OrdersTabPartyNet"]}</span>
                    <span className="col-md-6 text-right">{eventTotals.net.displayValue}</span>
                </div>
                <div className="row">
                    <span className="col-md-6">{resources["PWS.MyAccount.OrdersTabPartyTax"]}</span>
                    <span className="col-md-6 text-right">{eventTotals.tax.displayValue}</span>
                </div>
                <div className="row">
                    <span className="col-md-6">{resources["PWS.MyAccount.OrdersTabPartyFreight"]}</span>
                    <span className="col-md-6 text-right">{eventTotals.freight.displayValue}</span>
                </div>
                {eventTotals.directShip.amount != 0 && (
                    <div className="row">
                        <span className="col-md-6">{resources["PWS.MyAccount.OrdersTabPartyDirectShip"]}</span>
                        <span className="col-md-6 text-right">{eventTotals.directShip.displayValue}</span>
                    </div>
                )}
                <div style={{ borderTop: "3px solid black", margin: "10px auto" }}></div>
                <div className="row">
                    <span className="col-md-6">{resources["PWS.MyAccount.OrdersTabPartyTotal"]}</span>
                    <span className="col-md-6 text-right">{eventTotals.total.displayValue}</span>
                </div>
                <div style={{ borderTop: "3px solid black", margin: "10px auto" }}></div>
                <div className="row">
                    <span className="col-md-6">{resources["PWS.MyAccount.OrdersTabPartyBalance"]}</span>
                    <span className="col-md-6 text-right">{eventTotals.balance.displayValue}</span>
                </div>

                <div className="spacer12" />

                <div className="row">
                    <span className="col-md-12">
                        <h5>
                            <strong>{resources["PWS.MyAccount.OrdersTabHostRewardsSummary"]}</strong>
                        </h5>
                    </span>
                </div>

                {hostRewardsSummaries.map((hostRewardsSummary, key) => {
                    return (
                        <span key={key}>
                            <div className="row">
                                <span className="col-md-6">{resources["PWS.MyAccount.OrdersTabHostRewardsSummaryEarned"]}</span>
                                <span className="col-md-6 text-right">{hostRewardsSummary.earned}</span>
                            </div>
                            <div className="row">
                                <span className="col-md-6">{resources["PWS.MyAccount.OrdersTabHostRewardsSummaryUsed"]}</span>
                                <span className="col-md-6 text-right">{hostRewardsSummary.used}</span>
                            </div>
                            <div className="row">
                                <span className="col-md-6">{resources["PWS.MyAccount.OrdersTabHostRewardsSummaryRemaining"]}</span>
                                <span className="col-md-6 text-right">{hostRewardsSummary.remaining}</span>
                            </div>

                            <div className="spacer12" />
                        </span>
                    );
                })}
            </div>
        );
    };

    return (
        <div className="clearfix">
            <div className="formSectionSubTitle input-33">{resources["PWS.MyAccount.OrdersTabPartyOrdersLabel"]}</div>
            <div className="spacer12" />
            <div className="dottedHR" />

            <div className="row">
                <div className="col-md-8">{renderOrdersTable()}</div>
                <div className="col-md-4">{renderEventTotals()}</div>
            </div>

            <div className="spacer12" />
            <div className="dottedHR" />
        </div>
    );
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/Tab_Orders_Grid.js